import Link from "next/link";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import { HomeIcon } from "@public/images/svg/Footer/HomeIcon";
import { ChallengesIcon } from "@public/images/svg/Footer/ChallengesIcon";
import { AssistantIcon } from "@public/images/svg/AssistantIcon";
import { AiTipsIcon } from "@public/images/svg/Footer/AiTipsIcon";
import { $platform } from "@features/launch-context/model";
import { useUnit } from "effector-react";

export const FooterBase = () => {
    const pathname = usePathname();
    const platform = useUnit($platform);

    const isPolicyPage =
        pathname.includes("terms") ||
        pathname.includes("privacy") ||
        pathname.includes("terms") ||
        pathname.includes("experiment") ||
        pathname.includes("/creator") ||
        pathname.includes("/upsell");

    return isPolicyPage ? (
        <></>
    ) : (
        <footer
            className={clsx(
                "text-xs bg-white w-full h-[77px] border-t-2 border-white-700 z-20 touch-none",
                pathname !== "/payment" &&
                    pathname !== "/" &&
                    pathname !== "/auth/signin" &&
                    pathname !== "/auth/signup" &&
                    !pathname.startsWith("/onboarding")
                    ? "flex"
                    : "hidden"
            )}
        >
            <div
                className={clsx(
                    "max-w-[500px] w-full flex justify-center items-center mx-auto",
                    platform === "ios" && "mb-1"
                )}
            >
                <Link
                    href={"/home"}
                    className={clsx(
                        "basis-1/4 flex flex-col items-center",
                        pathname === "/home" ? "text-blue-100" : "text-white-500 hover:text-white-600"
                    )}
                    key={"home"}
                >
                    <HomeIcon active={pathname === "/home"} />

                    <strong className="app-footer__tab-title mt-1">Home</strong>
                </Link>

                <Link
                    href={"/challenges"}
                    className={clsx(
                        "basis-1/4 flex flex-col items-center",
                        pathname.includes("/challenge") ? "text-blue-100" : "text-white-500 hover:text-white-600"
                    )}
                    key={"challenges"}
                >
                    <ChallengesIcon active={pathname.includes("challenge")} />

                    <strong className="app-footer__tab-title mt-1">Challenges</strong>
                </Link>

                <Link
                    href="/ai-tips"
                    className={clsx(
                        "basis-1/4 flex flex-col items-center",
                        pathname.includes("/ai-tips") ? "text-blue-100" : "text-white-500 hover:text-white-600"
                    )}
                    key="ai-tips"
                >
                    <AiTipsIcon active={pathname.includes("ai-tip")} />

                    <strong className="app-footer__tab-title mt-1">AI tips</strong>
                </Link>

                <Link
                    href={"/assistant"}
                    className={clsx(
                        "basis-1/4 flex flex-col items-center",
                        pathname === "/assistant" ? "text-blue-100" : "text-white-500 hover:text-white-600"
                    )}
                    key={"assistant"}
                >
                    <AssistantIcon active={pathname === "/assistant"} />

                    <strong className="app-footer__tab-title mt-1">AI Tools</strong>
                </Link>

                {/* <Link href={"/profile"}
					className={clsx("basis-1/4 flex flex-col items-center", pathname === "/profile" ? "text-blue-100" : "text-white-500 hover:text-white-600")}
					key={"Profile"}>

					<PersonIcon active={pathname.includes("profile")} />

					<strong className="app-footer__tab-title mt-1">Profile</strong>
				</Link> */}
            </div>
        </footer>
    );
};
